import { render, staticRenderFns } from "./mentions-legales.vue?vue&type=template&id=e5296cec&scoped=true&"
import script from "./mentions-legales.vue?vue&type=script&lang=ts&"
export * from "./mentions-legales.vue?vue&type=script&lang=ts&"
import style0 from "./mentions-legales.vue?vue&type=style&index=0&id=e5296cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5296cec",
  null
  
)

export default component.exports